var _circle, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#7C3AED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 12,
    x2: 32,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 12,
    x2: 44,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 24,
    x2: 32,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 28,
    x2: 44,
    y2: 24
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 50,
    textAnchor: "middle",
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: "0.8px",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif"
  }, "\r\n        \u0420\u041A\r\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRk);
export default __webpack_public_path__ + "static/media/rk.4fdd464c0584e02c2b44aa8a6ddb6c4f.svg";
export { ForwardRef as ReactComponent };